import { render, staticRenderFns } from "./SecondaryActivation.vue?vue&type=template&id=66d587e8"
import script from "./SecondaryActivation.vue?vue&type=script&lang=js"
export * from "./SecondaryActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports